var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFullMarkinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  viewBox: "0 0 100 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.3542 0H24.7L39 39H29.8458C24.2956 33.3544 16.8203 32.4311 10.9129 33.5144L8.9375 39H0L14.3542 0ZM19.3375 10.0487L14.4625 23.6825L13.7484 25.659C17.5106 25.4814 21.6445 25.9565 25.6713 27.4937L24.2667 23.6825L19.3375 10.0487Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M69 39V0H60V39H69Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M85.25 39.5C93.91 39.5 100 33.4891 100 24.5273C100 15.5656 93.91 9.5 85.25 9.5C76.5341 9.5 70.5 15.5656 70.5 24.5273C70.5 33.4891 76.5341 39.5 85.25 39.5ZM85.25 32.3962C81.6742 32.3962 79.3835 29.5546 79.3835 24.5273C79.3835 19.5 81.6742 16.6585 85.25 16.6585C88.8258 16.6585 91.1165 19.5 91.1165 24.5273C91.1165 29.5546 88.8258 32.3962 85.25 32.3962Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M58.5 10.1094V18.5359C57.5755 18.3717 56.923 18.317 55.9441 18.317C52.1918 18.317 49.2009 20.6698 49.2009 24.8283V39H40.5V10.1642H49.2009V13.9396C50.506 11.6415 53.2795 10 56.5967 10C57.4124 10 57.9562 10.0547 58.5 10.1094Z"
})));
export default SvgFullMarkinline;